// CourseReadingComprehension.jsx
import React, { useEffect, useMemo, useState } from "react";
import "./ReadingComprehension.css";
import logo from "./bluelogo.png";
// videos
import ReadingVideo1 from "./CourseContainer/ReadingComprehension/Text 1.mp4";
import GrammarVideo14 from "./CourseContainer/Grammar/Reported speech part 1(1080P_HD).mp4";
import GrammarVideo15 from "./CourseContainer/Grammar/Reported speech part2(1080P_HD).mp4";
import GrammarVideo16 from "./CourseContainer/Grammar/Reported speech part 3(1080P_HD).mp4";
import GrammarVideo2 from "./CourseContainer/Grammar/Unit 2_ modal verbs part 1 2bac - أبسط شرح على اليوتيب(1080P_HD).mp4";
import GrammarVideo3 from "./CourseContainer/Grammar/modal verbs part2(1080P_HD).mp4";
import GrammarVideo4 from "./CourseContainer/Grammar/أبسط شرح على اليوتيب _Modal verbs in English part 3(1080P_HD).mp4";
import GrammarVideo5 from "./CourseContainer/Grammar/simple modals exercises 2025(1080P_HD).mp4";
import GrammarVideo6 from "./CourseContainer/Grammar/perfect modals(1080P_HD).mp4";
import GrammarVideo12 from "./CourseContainer/Grammar/Expressing purpose without mistakes(1080P_HD) (1).mp4";
import GrammarVideo13 from "./CourseContainer/Grammar/Expressing purpose Exercises without mistakes(1080P_HD) (1).mp4";
import GrammarVideo8 from "./CourseContainer/Grammar/Passive voice(1080P_HD).mp4";
import GrammarVideo10 from "./CourseContainer/Grammar/wish and if only(1080P_HD).mp4";
import GrammarVideo7 from "./CourseContainer/Grammar/relative pronouns 2026 PROOOOO(1080P_HD).mp4";
import GrammarVideo9 from "./CourseContainer/Grammar/conditional type 3(1080P_HD).mp4";
import GrammarVideo11 from "./CourseContainer/Grammar/Expressing regret(1080P_HD).mp4";
import GrammarVideo17 from "./CourseContainer/Grammar/Prefixes and suffixes(1080P_HD).mp4";
import GrammarVideo18 from "./CourseContainer/Grammar/phrasal verbs 2026 pro(1080P_HD).mp4";
import GrammarVideo19 from "./CourseContainer/Grammar/National grammar exam 1(1080P_HD).mp4";

import ReadingComprehensionIntro from "./CourseContainer/Grammar/intro to grammar.mp4";

// pdfs
import GrammarVideo1Pdf from "./CourseContainer/pdfs/Grammar/gerund and infinitive.pdf";
import GrammarVideo5Pdf from "./CourseContainer/pdfs/Grammar/simple modals.pdf";
import GrammarVideo6Pdf from "./CourseContainer/pdfs/Grammar/perfect modals.pdf";
// import GrammarVideo12Pdf from './CourseContainer/pdfs/Grammar/expressing purpose 2026(1080P_HD).pdf'
import GrammarVideo13Pdf from "./CourseContainer/pdfs/Grammar/Expresing purpose.pdf";
import GrammarVideo8Pdf from "./CourseContainer/pdfs/Grammar/passive voice.pdf";
import GrammarVideo10Pdf from "./CourseContainer/pdfs/Grammar/wish and if only.pdf";
import GrammarVideo7Pdf from "./CourseContainer/pdfs/Grammar/relative pronouns.pdf";
import GrammarVideo9Pdf from "./CourseContainer/pdfs/Grammar/conditionals.pdf";
// import GrammarVideo11Pdf from './CourseContainer/pdfs/Grammar/expressing regret.pdf'
import GrammarVideo12Pdf from "./CourseContainer/pdfs/Grammar/Prefixes and suffixes.pdf";
import GrammarVideo14Pdf from "./CourseContainer/pdfs/Grammar/phrasal verbs.pdf";
// import GrammarVideo19Pdf from './CourseContainer/pdfs/Grammar/National ReadingComprehension exam 1(1080P_HD).pdf'

import GrammarVideo11Pdf from "./CourseContainer/pdfs/Grammar/reported speech.pdf";

import Footer from "./Footer";
import Header from "./Header";

export default function CourseReadingComprehension() {
  // const tabs = ["Gerund & Infinitive", "Modal Verbs", "Passive Voice", ">>>"];
  const [activeTab, setActiveTab] = useState("Exams");
  const [query, setQuery] = useState("");

  // which accordion cards are open
  const [openIds, setOpenIds] = useState(() => new Set());

  // only one inline video open at a time
  const [openInlineVideo, setOpenInlineVideo] = useState(null); // { lessonId, itemId, videoSrc, title, subtitle }

  const lessons = useMemo(
    () => [
      {
        id: "introduction-to-ReadingComprehension",
        title: "Text 1",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "gintro-p1",
            label: "Lesson",
            duration: "24:07 min",
            videoSrc: ReadingVideo1,
          },
        ],
      },
      {
        id: "Gerund-and-Infinitive",
        title: "Text 2",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "gerund1-p1",
            label: "Lesson",
            duration: "12:54 min",
            // videoSrc: GrammarVideo1,
          },

        //   {
        //     id: "gps-pdf",
        //     label: "Exercise + Summary",
        //     kind: "exercise",
        //     pdfSrc: GrammarVideo1Pdf,
        //   },
        ],
      },
      {
        id: "simple_modals",
        title: "Text 3",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "gad-p1",
            label: "Lesson",
            duration: "12:41 min",
            // videoSrc: GrammarVideo2,
          },
          

        //   {
        //     id: "gps-pdf",
        //     label: "Exercise + Summary",
        //     kind: "exercise",
        //     pdfSrc: GrammarVideo5Pdf,
        //   },
        ],
      },
      {
        id: "PerfectModal",
        title: "Text 4",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "gaa-p1",
            label: "Lesson",
            duration: "12:41 min",
            // videoSrc: GrammarVideo6,
          },

        //   {
        //     id: "gps-pdf",
        //     label: "Exercise + Summary",
        //     kind: "exercise",
        //     pdfSrc: GrammarVideo6Pdf,
        //   },
        ],
      },
      {
        id: "Relative-Pronouns",
        title: "Text 5",
        // subtitle: "Timeline + signal words",
        // meta: ["1 lesson", "10 min"],
        items: [
          {
            id: "gac-p1",
            label: "Lesson",
            duration: "12:41 min",
            // videoSrc: GrammarVideo7,
          },

        //   {
        //     id: "gps-pdf",
        //     label: "Exercise + Summary",
        //     kind: "exercise",
        //     pdfSrc: GrammarVideo7Pdf,
        //   },
        ],
      },
     
    ],
    []
  );

  const filteredLessons = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return lessons;
    return lessons.filter((l) =>
      `${l.title} ${l.subtitle}`.toLowerCase().includes(q)
    );
  }, [lessons, query]);

  const toggleAccordion = (lessonId) => {
    setOpenIds((prev) => {
      const next = new Set(prev);
      if (next.has(lessonId)) next.delete(lessonId);
      else next.add(lessonId);
      return next;
    });
  };

  const toggleInlineVideo = ({
    lessonId,
    itemId,
    videoSrc,
    title,
    subtitle,
  }) => {
    setOpenInlineVideo((curr) => {
      if (curr && curr.lessonId === lessonId && curr.itemId === itemId)
        return null;
      return { lessonId, itemId, videoSrc, title, subtitle };
    });
  };

  // icons defined INSIDE this file (simple)
  const IconPlay = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
      <path d="M9 7.5v9l8-4.5-8-4.5Z" fill="#4b5563" />
    </svg>
  );

  const IconPlaySmall = () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
      <path d="M9 7.5v9l8-4.5-8-4.5Z" fill="#6b7280" />
    </svg>
  );

  const IconChevronDown = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d="M7 10l5 5 5-5H7Z" fill="#6b7280" />
    </svg>
  );

  const IconCheck = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
      <path
        d="M9.2 16.2 5.5 12.5 4.1 13.9l5.1 5.1L20 8.2 18.6 6.8 9.2 16.2Z"
        fill="#16a34a"
      />
    </svg>
  );
  useEffect(() => {
    // Scroll to the top of the page
    window.scrollTo(0, 0);
  }, []);

  window.onscroll = function () {
    const header = document.getElementById("All__courses__header");
    const headerLogo = document.querySelector("#All__courses__header img");

    if (window.scrollY > 50) {
      headerLogo.style.width = "60px";

      header.style.transition = "background 0.3s ease-in-out";
    } else {
      if (window.innerWidth < "668") {
        headerLogo.style.width = "60px";
        header.style.background = "white";
      } else {
        headerLogo.style.width = "60px";
        header.style.background = "white";
      }
    }
  };
  useEffect(() => {
    const header = document.getElementById("All__courses__header");
    const headerLogo = document.querySelector("#All__courses__header img");
    headerLogo.style.width = "60px";
    header.style.background = "white";
  }, []);
  function scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  return (
    <div className="ReadingComprehensionContainer">
      <header id="All__courses__header">
        <a href="https://toustousacademy.com/">
          <img className="ReadingComprehension__header__img" src={logo} alt="" />
        </a>
        <ul>
          <a href="/" onClick={scrollToTop}>
            <li>Home</li>
          </a>
          <a href="/#about">
            <li>About</li>
          </a>
          <a href="/#feedback">
            <li>Feedback</li>
          </a>
        </ul>
      </header>
      <div className="tp-page">
        <div className="tp-container">
          <header className="tp-header">
            <h1 className="tp-title">Reading Comprehension</h1>
            {/* <p className="tp-subtitle">
              Short lessons + practice + correction.
            </p> */}
          </header>

          <div className="tp-toolbar">
            {/* <div className="tp-tabs">
              {tabs.map((t) => (
                <button
                  key={t}
                  className={`tp-tab ${activeTab === t ? "is-active" : ""}`}
                  onClick={() => setActiveTab(t)}
                  type="button"
                >
                  <span>{t}</span>
                  {t === "Exams" || t === "Future"}
                </button>
              ))}
            </div> */}
          </div>

          <main className="tp-list">
            {filteredLessons.map((lesson) => {
              const isOpen = openIds.has(lesson.id);

              return (
                <article key={lesson.id} className="tp-card">
                  {/* Accordion header */}
                  <button
                    className="tp-accHeader"
                    type="button"
                    onClick={() => toggleAccordion(lesson.id)}
                  >
                    <div className="tp-accLeft">
                      <div className="tp-playCircle" aria-hidden="true">
                        <IconPlay />
                      </div>

                      <div className="tp-cardMain">
                        <div className="tp-cardTitle">{lesson.title}</div>
                        <div className="tp-cardSub">{lesson.subtitle}</div>

                        {lesson.meta && (
                          <div className="tp-pills">
                            {lesson.meta.map((m) => (
                              <span key={m} className="tp-pill">
                                {m}
                              </span>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>

                    <span className={`tp-accChev ${isOpen ? "is-open" : ""}`}>
                      <IconChevronDown />
                    </span>
                  </button>

                  {/* Accordion body */}
                  <div className={`tp-accBody ${isOpen ? "is-open" : ""}`}>
                    {lesson.items.map((it) => {
                      const isExercise = it.kind === "exercise";
                      const isThisVideoOpen =
                        openInlineVideo?.lessonId === lesson.id &&
                        openInlineVideo?.itemId === it.id;

                      return (
                        <div key={it.id} className="tp-itemBlock">
                          <div
                            className={`tp-itemRow ${
                              isExercise ? "is-exercise" : ""
                            }`}
                          >
                            <div className="tp-itemLeft">
                              <div
                                className={
                                  isExercise
                                    ? "tp-checkCircle"
                                    : "tp-smallPlayCircle"
                                }
                                aria-hidden="true"
                              >
                                {isExercise ? <IconCheck /> : <IconPlaySmall />}
                              </div>
                              <div className="tp-itemTitle">{it.label}</div>
                            </div>

                            <div className="tp-itemRight">
                              <div className="tp-partDur">
                                {it.duration || ""}
                              </div>

                              {isExercise ? (
                                <a
                                  className="tp-playBtn tp-playBtnLight"
                                  href={it.pdfSrc}
                                  download
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  Download PDF
                                  {/* <span className="tp-playBtnChev">›</span> */}
                                </a>
                              ) : (
                                <button
                                  className="tp-playBtn"
                                  type="button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    toggleInlineVideo({
                                      lessonId: lesson.id,
                                      itemId: it.id,
                                      videoSrc: it.videoSrc,
                                      title:
                                        it.label === "Click Play >>"
                                          ? lesson.title
                                          : `${lesson.title} — ${it.label}`,
                                      subtitle: lesson.subtitle,
                                    });
                                  }}
                                >
                                  {isThisVideoOpen ? "Hide" : "Play"}{" "}
                                  <span className="tp-playBtnChev">›</span>
                                </button>
                              )}
                            </div>
                          </div>

                          {/* inline video under the row */}
                          {isThisVideoOpen && (
                            <div className="tp-inlineVideoWrap">
                              <div className="tp-inlineVideoHeader">
                                <div className="tp-inlineVideoTitle">
                                  {openInlineVideo.title}
                                </div>
                                <div className="tp-inlineVideoSub">
                                  {openInlineVideo.subtitle}
                                </div>
                              </div>

                              <video
                                key={openInlineVideo.videoSrc}
                                className="tp-inlineVideo"
                                controlsList="nodownload noplaybackrate"
                                disablePictureInPicture
                                onContextMenu={(e) => e.preventDefault()}
                                controls
                                autoPlay
                                src={openInlineVideo.videoSrc}
                              />
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </article>
              );
            })}
          </main>
        </div>
      </div>
      <Footer />
    </div>
  );
}
